import {collectEnumValues, makeEnumTypeGuard} from '../../../libs/shared/helpers/src/typescript/enumHelpers';
import {isDefined} from '../../../libs/shared/helpers/src/typescript/typeHelpers';

/*
 * Types.
 */

export enum ModifiersEnum {
  ACCOUNT = 'account',
  AFTER = 'after',
  ASSIGNEE = 'assignee',
  AUTHOR = 'author',
  BCC = 'bcc',
  BEFORE = 'before',
  BODY = 'body',
  CC = 'cc',
  COMMENTER = 'commenter',
  DURING = 'during',
  FROM = 'from',
  HAS = 'has',
  ID = 'id',
  IN = 'in',
  INBOX = 'inbox',
  IS = 'is',
  MENTION = 'mention',
  PARTICIPANT = 'participant',
  RECIPIENT = 'recipient',
  SUBJECT = 'subject',
  TAG = 'tag',
  TO = 'to',
  TYPE = 'type',
  INCLUDE = 'include',
}

export const modifiersSet = new Set(collectEnumValues(ModifiersEnum));

const validModifierValues = new Map(
  Object.entries({
    [ModifiersEnum.IS]: [
      'archived',
      'assigned',
      'discussion',
      'open',
      'shared-with-me',
      'snoozed',
      'spam',
      'starred',
      'subscribed',
      'trashed',
      'unassigned',
      'unread',
      'unreplied',
      'unsubscribed',
    ],
    [ModifiersEnum.HAS]: [
      'attachment',
      'attachments',
      'calendar',
      'draft',
      'follower',
      'followers',
      'no-tag',
      'no-tags',
      'reminder',
      'subscriber',
      'subscribers',
    ],
    [ModifiersEnum.IN]: ['all', 'attachments', 'comments', 'messages'],
    [ModifiersEnum.TYPE]: [
      'call',
      'custom',
      'discussion',
      'email',
      'facebook',
      'front_chat',
      'googleplay',
      'intercom',
      'internal',
      'layer',
      'phone-call',
      'smooch',
      'sms',
      'tweet_dm',
      'tweet',
      'whatsapp',
      'yalo_wha',
    ],
  }),
);

/*
 * Type guards.
 */

export const isExistingModifier = makeEnumTypeGuard(ModifiersEnum);

/*
 * Helpers.
 */

export function isValidValueForModifier(modifier: ModifiersEnum, value: string | undefined): boolean {
  if (
    isDefined(value) &&
    validModifierValues.has(modifier) &&
    !(validModifierValues.get(modifier) || []).includes(value.trim())
  ) {
    return false;
  }

  return true;
}
